import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useCallback, useState } from 'react';
import defaultClasses from './submitClaim.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { Form } from 'informed';
import OrderInformation from './OrderInformation'; // import AccountSidebarWrapper from '../accountSidebarWrapper';

import ClaimItemInformation from './ClaimItemInformation';
import { Button, TextArea } from '../../../components';
import { CLAIMS_MUTATION } from './queries';
import { useMutation, useQuery } from '@apollo/client';
import Field from '@magento/venia-ui/lib/components/Field';
import { GET_CUSTOMER_CLAIMS, EPICOR_ORDER_DETAIL } from '../MyClaims/queries';
import useToast from '../../../hooks/useToast';

var SubmitClaim = function SubmitClaim(_ref) {
  var _orderDetailsData$epi;

  var order = _ref.order,
      propClasses = _ref.classes;

  var _useMutation = useMutation(CLAIMS_MUTATION),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      claimsMutation = _useMutation2[0];

  var formApiRef = useRef(null);
  var setFormFormApi = useCallback(function (api) {
    return formApiRef.current = api;
  }, []);

  var _useToast = useToast(),
      addMessage = _useToast.addMessage;

  var classes = useStyle(defaultClasses, propClasses);

  var _useQuery = useQuery(GET_CUSTOMER_CLAIMS, {
    variables: {
      input: {
        filter: {
          number: order === null || order === void 0 ? void 0 : order.order_number
        }
      }
    },
    fetchPolicy: 'cache-and-network'
  }),
      data = _useQuery.data,
      loading = _useQuery.loading,
      error = _useQuery.error;

  var _useQuery2 = useQuery(EPICOR_ORDER_DETAIL, {
    variables: {
      filter: {
        order_num: {
          eq: order === null || order === void 0 ? void 0 : order.order_number
        }
      }
    },
    fetchPolicy: 'cache-and-network'
  }),
      orderDetailsData = _useQuery2.data;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItemNumber = _useState2[0],
      setSelectedItemNumber = _useState2[1];

  var orderDetails = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : (_orderDetailsData$epi = orderDetailsData.epicorOrderDetail) === null || _orderDetailsData$epi === void 0 ? void 0 : _orderDetailsData$epi.order[0];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      formSubmitted = _useState4[0],
      setFormSubmitted = _useState4[1];

  var submitClaims = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return claimsMutation({
                variables: {
                  input: {
                    email: values === null || values === void 0 ? void 0 : values.email,
                    comments: (values === null || values === void 0 ? void 0 : values.comments) || '',
                    order_no: order === null || order === void 0 ? void 0 : order.order_number,
                    shipping_address: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_1) || '',
                    shipping_city: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_city,
                    shipping_country: 'US',
                    shipping_name: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_customer_name,
                    shipping_state: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_state) || '',
                    shipping_zip: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_zip) || '',
                    claimes_items: values === null || values === void 0 ? void 0 : values.claims_items.map(function (item) {
                      var _item$reason_to_retur;

                      return _objectSpread(_objectSpread({}, item), {}, {
                        item_name: item === null || item === void 0 ? void 0 : item.item_name.label,
                        reason_to_return: (item === null || item === void 0 ? void 0 : (_item$reason_to_retur = item.reason_to_return) === null || _item$reason_to_retur === void 0 ? void 0 : _item$reason_to_retur.value) || ''
                      });
                    })
                  }
                }
              });

            case 2:
              try {
                addMessage('success', ' Form successfully submitted.');
                setFormSubmitted(true);
                formApiRef.current.reset();
              } catch (error) {
                addMessage('error', ' Something went wrong.');
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submitClaims(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var initialValues = {
    email: '',
    comment: '',
    claims_items: [{
      item_name: {
        label: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.line_details[0].product_name_1,
        value: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.line_details[0].product_name_2
      },
      claimquantity: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.line_details[0].qty,
      item_number: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.line_details[0].product_name_2,
      condition: '',
      reference_number: (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.reference_number) !== '0' ? orderDetails.reference_number : 'N/A'
    }]
  };

  var handleItemChange = function handleItemChange() {
    var _formValues$claims_it;

    var formValues = formApiRef.current.getValues();
    formValues === null || formValues === void 0 ? void 0 : (_formValues$claims_it = formValues.claims_items) === null || _formValues$claims_it === void 0 ? void 0 : _formValues$claims_it.forEach(function (claimItem, index) {
      var val = formApiRef.current.getValue('claims_items[' + index + '].item_name');
      formApiRef.current.setValue('claims_items[' + index + '].item_number', val.value || val);
    });
  };

  if (formSubmitted) {
    window.scrollTo(0, 0);
    return React.createElement("div", {
      className: "py-8 col-span-12"
    }, React.createElement("p", {
      className: "text-bronze font-bold"
    }, "Claim successfully submitted. Our Customer Service will contact you soon."));
  }

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-span-12"
  }, React.createElement("h1", {
    "aria-live": "polite",
    className: "".concat(classes.title, " h3")
  }, "Submit a Claim"), React.createElement(Form, {
    getApi: setFormFormApi,
    initialValues: initialValues,
    onSubmit: submitClaims
  }, React.createElement(OrderInformation, {
    classes: classes,
    order: order,
    customer: data === null || data === void 0 ? void 0 : data.customer,
    orderDetails: orderDetails,
    selectedItemNumber: selectedItemNumber
  }), React.createElement(ClaimItemInformation, {
    classes: classes,
    order: order,
    handleItemChange: handleItemChange,
    orderDetails: orderDetails
  }), React.createElement("div", {
    className: classes.textAreaContainer
  }, React.createElement(Field, {
    id: "comments",
    label: "comments"
  }, React.createElement(TextArea, {
    field: "comments",
    id: "comments" // validate={isRequired}
    ,
    placeholder: 'Comments',
    initialValue: '' // maxLength={150}
    ,
    classes: {
      input: classes.textAreaInput
    }
  }))), React.createElement("div", {
    className: classes.submitContainer
  }, React.createElement(Button, {
    priority: "low",
    type: "submit",
    "aria-label": "Submit claim"
  }, "SUBMIT")))));
};

export default SubmitClaim;